const getters = {
  test: state => state.app.test
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js